import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './TS_Slider.scss';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import { LL_H_C } from '../Layouts/index.js';
export class TS_Slider extends ComponentSync {
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps) {
        return {
            value: nextProps.value === undefined ? this.getValue() : nextProps.value
        };
    }
    // ######################### Logic #########################
    getValue() {
        return this.state?.value ?? this.props.startValue ?? (this.props.min + this.props.max) / 2;
    }
    onValueChange = (e) => {
        let value = e.target.valueAsNumber;
        if (isNaN(value))
            value = undefined;
        this.setState({ value }, () => {
            this.props.onValueChanged?.(value ?? this.props.min);
        });
    };
    onMouseUp = (e) => {
        this.props.onValueSet?.(this.state.value ?? this.props.min);
    };
    calculateBGSize = () => {
        return (((this.state.value ?? this.props.min) - this.props.min) * 100) / (this.props.max - this.props.min);
    };
    // ######################### Render #########################
    renderCurrentValue() {
        return _jsx("input", { className: 'ts-slider__current-value', type: 'number', value: this.state.value, onChange: this.onValueChange });
    }
    renderSliderInput() {
        return _jsx("input", { type: 'range', value: this.state.value ?? this.props.min, min: this.props.min, max: this.props.max, onChange: this.onValueChange, onMouseUp: this.onMouseUp, style: { backgroundSize: `${this.calculateBGSize()}% 100%` } });
    }
    render() {
        const className = _className('ts-slider', this.props.className);
        return _jsxs(LL_H_C, { className: className, children: [this.renderSliderInput(), this.renderCurrentValue()] });
    }
}
//# sourceMappingURL=TS_Slider.js.map